import React from "react";
import { ClockIcon, LeftChevron, RightChevron } from "../Icons";
import { useAuthContext } from "../../context/auth";
import { TimerRenderer } from "react-use-precision-timer";

/** 회원용 모니터의 수업 경과 시간. 하단 바 대신 화면 왼쪽 위에 얹는다. */
function MemberClassTimer() {
  const { timer } = useAuthContext();
  return (
    <div className="absolute left-[40px] top-[12px] z-30 flex items-center gap-[12px] pointer-events-none">
      <div className="[&>svg]:w-[44px] [&>svg]:h-[44px]">
        <ClockIcon />
      </div>
      <TimerRenderer
        timer={timer}
        render={(t) => (
          <p className="gradient-text text-[44px] leading-[56px]">
            {String(Math.floor(t.getElapsedRunningTime() / 1000 / 60)).padStart(
              2,
              "0"
            )}
            :
            {String(Math.floor((t.getElapsedRunningTime() / 1000) % 60)).padStart(
              2,
              "0"
            )}
          </p>
        )}
        renderRate={500} // In milliseconds
      />
    </div>
  );
}

/**
 * 컨트롤 화면(did 0)의 하단 바. 회원용 모니터(did 1)는 누를 일이 없어 바를 빼고 그 높이를 화면에
 * 돌려준다. 화면에 수업 시간이 이미 있으면 hideMemberTimer 로 왼쪽 위 시간을 뺀다.
 */
function BottomNav({ hideMemberTimer = false }: { hideMemberTimer?: boolean }) {
  const { timer, sendSetStep, step, did } = useAuthContext();
  if (did === "1") return hideMemberTimer ? null : <MemberClassTimer />;
  return (
    <>
      <div className="flex-1" />
      <div className="flex w-full h-[132px]">
        <div
          className="w-[132px] h-[132px] flex justify-center items-center bg-[#48505F]"
          onClick={() => {
            sendSetStep(step - 1);
          }}
        >
          <LeftChevron />
        </div>
        <div className="flex-1 flex justify-center items-center h-full relative">
          <button
            className="absolute left-[70px] text-[40px] font-bold text-white"
            onClick={() => {
              if (window.confirm("정말로 첫 화면으로 돌아가시겠습니까?"))
                sendSetStep(0);
            }}
          >
            첫 화면으로
          </button>
          <div className="flex gap-4 items-center">
            <ClockIcon />
            <TimerRenderer
              timer={timer}
              render={(t) => (
                <>
                  <div className="flex">
                    <p className="gradient-text text-[64px]">
                      {String(
                        Math.floor(t.getElapsedRunningTime() / 1000 / 60)
                      ).padStart(2, "0")}
                    </p>
                    <p className="gradient-text text-[64px]">:</p>
                    <p className="gradient-text text-[64px]">
                      {String(
                        Math.floor((t.getElapsedRunningTime() / 1000) % 60)
                      ).padStart(2, "0")}
                    </p>
                  </div>
                </>
              )}
              renderRate={500} // In milliseconds
            />
          </div>
        </div>
        <div
          className="w-[132px] h-[132px] flex justify-center items-center bg-[#48505F]"
          onClick={() => {
            sendSetStep(step + 1);
          }}
        >
          <RightChevron />
        </div>
      </div>
    </>
  );
}

export default BottomNav;
